import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { SyncOptionRadioGroup } from "./fields/SyncOptionRadioGroup";

export const RentvineCredentialForm = ({ register }: CredentialFormProps) => {
  const syncField = register("rentvine_sync");

  return (
    <>
      <BaseInput
        id="rentvine_account"
        label="Account"
        {...register("rentvine_account")}
        required
      />
      <BaseInput
        id="rentvine_api_key"
        label="API Key"
        {...register("rentvine_api_key")}
        required
      />
      <BaseInput
        id="rentvine_api_secret"
        label="API Secret"
        {...register("rentvine_api_secret")}
        required
      />

      <SyncOptionRadioGroup
        field={syncField}
        prose={
          <>
            Sync Rentvine{" "}
            <span className="font-bold">&quot;Advertising&quot;</span> status
            with the ability to submit applications
          </>
        }
      />
    </>
  );
};
